import cn from 'classnames';
import styles from './Icon.module.scss';

export type IconProps = {
  icon: string;
  title?: string;
  class?: string;
};

/**
 * While we wait for a DS one
 *
 * @deprecated
 */
export default function Icon({ icon, title, class: className }: IconProps) {
  return (
    <span
      class={cn(className, styles.icon)}
      style={{
        /** @ts-ignore */
        '--js-url': `url(/shared_res/agility/next-components/assets/icons/${icon}.svg)`
      }}
      title={title}
    />
  );
}
